module.exports = __webpack_public_path__ + "static/media/Scene 4.2d7a4e78.jpg";